// src/pages/AdminDashboard.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminBookings from "../components/AdminBookings";
import "./AdminDashboard.css"; // Make sure CSS is imported
import api from "../utils/api"; // (for axios calls elsewhere)


const AdminDashboard = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Summary stats
  const [totalPayments, setTotalPayments] = useState(0);
  const [uniqueCustomers, setUniqueCustomers] = useState(0);
  const [uniqueDrivers, setUniqueDrivers] = useState(0);

  useEffect(() => {
    api
      .get("/api/bookings")
      .then((res) => {
        const data = res.data;

        setBookings(data);

        // Calculate payments total
        const totalFare = data.reduce((acc, b) => acc + (parseFloat(b.fare) || 0), 0);
        setTotalPayments(totalFare);

        // Unique customers
        const customers = new Set(data.map(b => b.customer));
        setUniqueCustomers(customers.size);

        // Unique drivers
        const drivers = new Set(data.map(b => b.driver).filter(d => d && d !== ""));
        setUniqueDrivers(drivers.size);

        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error fetching bookings:", err);
        setError("Failed to load bookings");
        setLoading(false);
      });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
        width: "90%",
        margin: "0 auto",
      }}
    >
      <h2 style={{ marginBottom: "20px" }}>Admin Dashboard</h2>

      {/* ✅ Use the CSS tile-container instead of inline styling */}
      <div className="tile-container">
        <div className="tile">
          <h3>{bookings.length}</h3>
          <p>Total Bookings</p>
        </div>

        <div className="tile">
          <h3>£{totalPayments.toFixed(2)}</h3>
          <p>Total Payments</p>
        </div>

        <div className="tile">
          <h3>{uniqueDrivers}</h3>
          <p>Active Drivers</p>
        </div>

        <div className="tile">
          <h3>{uniqueCustomers}</h3>
          <p>Customers</p>
        </div>
      </div>

      {loading && <p>Loading bookings...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && <AdminBookings bookings={bookings} />}
    </div>
  );
};

export default AdminDashboard;

